//region :: Imports ::
import {ReactElement, ReactNode} from 'react';
import MComponent from '../Component';
import {MIcon} from '../../Icons';
import {DialogPositionType} from 'primereact/dialog';
import MDialog from './Dialog';

//endregion

/** */
type Props = {}

/** */
type State = {
    title?: string;
    message?: string | ReactNode;
    icon?: MIcon;
    footer?: ReactNode;
    position?: DialogPositionType;
    visible: boolean;
}

/** */
class MAlertDialog extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();

    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {visible: false};
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(title: string, message: string | ReactNode, icon?: MIcon, footer?: ReactNode, position?: DialogPositionType) {

        this.safeSetState((draft: State) => {

            draft.title = title;
            draft.message = message;
            draft.icon = icon;
            draft.footer = footer;
            draft.position = position;
            draft.visible = true;

        });

    }

    /** */
    public render(): ReactElement {

        return (
            <MDialog title={this.state.title ?? ''}
                     content={this.state.message}
                     icon={this.state.icon}
                     footer={this.state.footer}
                     position={this.state.position}
                     canClose={false}
                     closeOnEscape={false}
                     visible={this.state.visible}
                     onHide={this.dialog_onHide}/>
        );

    }

}

export default MAlertDialog;
